<template>
  <!-- Margen del proyecto: comercial vs actual, variación en p.p. y en €. -->
  <summary-card :title="$t('prm_dash_margin_title')" :mode="mode" chip="prm">
    <template #icon><b-icon pack="fas" icon="percent" size="is-small"></b-icon></template>

    <table class="kv">
      <tbody>
        <tr>
          <td class="k">{{ $t('prm_dash_margin_commercial') }}</td>
          <td class="v"><b>{{ pct(prmData.commercialMargin) }}</b></td>
        </tr>
        <tr>
          <td class="k">{{ $t('prm_dash_margin_actual') }}</td>
          <td class="v"><b>{{ pct(prmData.actualMargin) }}</b></td>
        </tr>
        <tr>
          <td class="k">{{ $t('prm_dash_margin_var_pp') }}</td>
          <td class="v">
            <sem-dot v-if="has" :state="color"></sem-dot>
            <b :style="{ color: accent }">{{ has ? ppSigned : '-' }}</b>
          </td>
        </tr>
        <tr>
          <td class="k">{{ $t('prm_dash_margin_var_eur') }}</td>
          <td class="v"><b :style="{ color: accent }">{{ eurSigned }}</b></td>
        </tr>
      </tbody>
    </table>
  </summary-card>
</template>

<script>
  import SummaryCard from '../summary/summary-card.vue'
  import SemDot from './sem-dot.vue'
  import { fmtPct, fmtEurSigned, fmtPctSigned } from '../shared/format'
  import { ACCENT, marginColor } from './dashboard-model'

  export default {
    name: 'PrmDashMargin',

    components: { SummaryCard, SemDot },

    props: {
      prm: { type: Object, default: null },
      totalAmount: { type: Number, default: 0 },
      mode: { type: Boolean, default: false },
    },

    computed: {
      has () { return this.prm != null },
      prmData () { return this.prm || {} },
      // Variación de margen (actual − comercial), en fracción.
      varFrac () { return this.has ? (Number(this.prmData.actualMargin) - Number(this.prmData.commercialMargin)) : 0 },
      varPp () { return this.varFrac * 100 },
      color () { return marginColor(this.prmData.commercialMargin, this.prmData.actualMargin) },
      accent () { return this.has ? (this.varFrac < 0 ? ACCENT.bad : ACCENT.good) : '' },
      ppSigned () { return fmtPctSigned(this.varPp) },
      // Variación de margen € = margen actual € − margen comercial €
      //   (actual % × importe total) − (comercial % × importe contractual).
      eurSigned () {
        if (!this.has) return '-'
        const v = Number(this.prmData.actualMargin) * (Number(this.totalAmount) || 0) -
                  Number(this.prmData.commercialMargin) * (Number(this.prmData.contractAmount) || 0)
        return fmtEurSigned(v)
      },
    },

    methods: {
      pct (v) { return this.has ? fmtPct(v) : '-' },
    },
  }
</script>

<style lang="scss" scoped>
  .kv { width: 100%; border-collapse: collapse; }
  .kv td { border-bottom: 1px solid #eef0f3; padding: 6px 10px; font-size: 11px; vertical-align: middle; }
  .kv tbody tr:nth-child(even) td { background: #f9fafb; }
  .kv tbody tr:hover td { background: #eef2f7; }
  .kv tr:last-child td { border-bottom: 0; }
  .k { color: #3d5570; }
  .v { text-align: right; white-space: nowrap; }
  .v b { font-weight: 700; font-variant-numeric: tabular-nums; margin-left: 6px; }
</style>
